import React from "react";

export interface AppContextInterface {
	token: string|null;
	setTokenValue: React.Dispatch<React.SetStateAction<string|null>>;

	loadingLogin: boolean|null;
	setLoadingLoginValue: React.Dispatch<React.SetStateAction<boolean|null>>;

	userID: string|null;
	setUserIDValue: React.Dispatch<React.SetStateAction<string|null>>;

	userEmail: string|null;
	setUserEmailValue: React.Dispatch<React.SetStateAction<string|null>>;
};

const AppContext = React.createContext<AppContextInterface|null>(null);

export default AppContext;